import styled from '@emotion/styled';
import Container from '@ep/components/Container';
import { H1 } from '@ep/templates/ProductPage';
import theme from '@ep/theme';
import { Gcms_RelatedProduct } from '@ep/types/gatsbyTypes';
import React from 'react';
import RelatedProduct, { RelatedProductProps } from './RelatedProduct';

export interface RelatedProductsModuleProps {
  heading: string;
  relatedProducts: Gcms_RelatedProduct[];
}

interface StyledContainerProps {
  relatedProductsLength: number;
}

const StyledContainer = styled(Container)<StyledContainerProps>`
  padding-top: 8rem !important;
  background-color: ${theme.colors.lightGray};
  max-width: 100%;
  position: relative;
  text-align: center;

  ${theme.mediaQueries.tabletAndDesktop} {
    margin: 0rem;
    max-width: 100%;
    padding: 4rem 0 5rem;
  }

  ${theme.mediaQueries.mobile} {
    margin: 0rem;
    max-width: 100%;
    padding: 3.75rem 0 4rem;
  }
`;

const Grid = styled.div`
  display: grid;
  padding-top: 1rem;
  margin-top: 3rem;
  grid-gap: 5rem 0px;
  justify-content: center;
  text-align: center;

  @media (max-width: ${theme.breakpoints.desktop}px) {
    grid-gap: 2rem 0px;
    grid-template-columns: repeat(1, 1fr) !important;
  }

  ${theme.mediaQueries.tablet} {
    grid-gap: 2rem 0px;
  }

  @media (max-width: ${theme.breakpoints.optimalTablet + 100}px) {
    grid-gap: 2rem 0px;
    grid-template-columns: repeat(1, 1fr) !important;
  }

  @media (max-width: ${theme.breakpoints.optimalMobile + 200}px) {
    grid-template-columns: minmax(0, 350px) !important;
    grid-gap: 2rem 10px;
  }
`;

const Header = styled.h2`
  color: ${theme.colors.duskBlue};
  font-family: ${theme.typography.semiBoldFont};
  font-size: 2.625rem;
  line-height: 1;
`;

function RelatedProductsModule({
  heading,
  relatedProducts,
}: RelatedProductsModuleProps) {
  const relatedProductsLength = relatedProducts.length;
  const hasHeading = Boolean(heading);
  return (
    <StyledContainer relatedProductsLength={relatedProducts.length}>
      {hasHeading && <Header>{heading}</Header>}
      <Grid
        style={{
          gridTemplateColumns: 'repeat(' + relatedProductsLength + ', 1fr)',
        }}
      >
        {relatedProducts?.map((relatedProduct, index) => (
          <RelatedProduct
            {...(relatedProduct as RelatedProductProps)}
            key={`Related_Product__${index}`}
          />
        ))}
      </Grid>
    </StyledContainer>
  );
}

export default React.memo(RelatedProductsModule);
